/*
 * @Author: 陈大仙人
 * @Date: 2022-07-14 16:33:51
 * @LastEditors: 陈大仙人
 * @LastEditTime: 2023-12-01 18:24:25
 * @FilePath: /akx-pc-main/src/login/main.js
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import api from './api'
import component from './components'
import './common/common.scss'
import { webviewAlert } from '../util/webviewapi'
Vue.config.productionTip = false;
Vue.prototype.$api = api
Vue.prototype.$component = component
// 安卓情况下 监听返回时间 关闭APP
window.$androidBackClick = () => {
  webviewAlert('确定退出吗？', '提示', null, key => {
    if (key === 1) {
      window.NativeBridge.exitApp();
    }
  });
};
window.$vue = new Vue({
  router,
  render: h => h(App)
}).$mount('#mainApp')
